module.exports = __webpack_public_path__ + "img/studyplan_menu.a5da0a77.png";